import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import CategoryCard from '@/components/base/CategoryCard';

export default function CategoryGrid() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
          热门行业分类
        </h2>
        <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
          覆盖12大行业类别，汇聚全国优质企业信息，助您快速找到需要的商业伙伴
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {categories.map((cat) => (
          <CategoryCard key={cat.id} category={cat} />
        ))}
      </div>

      <div className="mt-8 text-center">
        <Link
          to="/category/canyin-meishi"
          className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer"
        >
          查看全部行业分类
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-sm"></i>
          </div>
        </Link>
      </div>
    </section>
  );
}